import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Link from "../../UI/Link/Link"
import { labels } from "../../../constants/label.constants"
import * as styles from "./Header-tw-styles"
import { gaLogo, gaLogoLabel } from "../../../constants/gtm.constants"
import LanguageSelection from "./LanguageSelection/LanguageSelection"
import { get } from "../../../helpers/utils"
import useScreenSize from "../../../hooks/useScreenSize"
import NavigationDesktop from "./Navigation/Desktop/Navigation"
import NavigationMobile from "./Navigation/Mobile/Navigation"
import Image from "../../UI/Image/Image"

const Header = props => {
  const { logo, languageSelection, navigationCollection, variant, language } = props
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false)
  const [isActive,setIsActive] = useState("")

  if(typeof window !== "undefined"){
    
window.addEventListener("scroll", () => {
  document.querySelectorAll("div[id]").forEach(div => {
    const rect = div.getBoundingClientRect();
    if (rect.top >= 0 && rect.top < window.innerHeight / 2) {
      let link = navigationCollection?.items?.find(el=>el.link?.scrollToElementId == div?.id);
      if(link){
		  setIsActive(link.link.scrollToElementId)
      }
    }
  });
});

 }
  
  const style =  language=="en" ? styles[variant] : styles.defaultStyle
  const { headerContainer, headerContent, headerLogo, logoImg,logoImgLink } = style
  const screen = useScreenSize();
  // Navigate on respective language url from cookies pages
  const navigationDataRaw = get(navigationCollection, "items", []);
  // Helper to get language prefix for URLs
  const getLangPrefix = (lang) => (lang && lang.toLowerCase() !== "en" ? `/${lang.toLowerCase()}` : "/");
  const navigationData = navigationDataRaw?.map(item => {
    if (item.link && typeof item.link.url === "string" && item.link.url.startsWith("#")) {
      return {
        ...item,
        link: {
          ...item.link,
          url: getLangPrefix(language) + item.link.url,
        },
      };
    }
    return item;
  });

  const toggleMobileNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen)
  }
  
  const logoUrl = logo?.url

  return (
    <div className={headerContainer}>
      <div className={headerContent}>
        <div className={headerLogo}>
          <Link url={"https://www.mondelezinternational.com/"} className={`${logoImgLink} image_click_logo`} gaEventLabel="snackmindful- logo">
            <Image 
              src={logoUrl}
              className={logoImg}
              alt={logo?.description || logo?.title}
              eventClass={gaLogo}
              eventLabel={gaLogoLabel}
              width={labels?.header?.logo?.width}
              height={labels?.header?.logo?.height}
              fetchpriority="high"
              loading="eager"
            />
            {/* <MondelezeImage
              className={logoImg}
              alt={logo?.description || logo?.title}
              src={logoUrl}
              width={labels?.header?.logo?.width}
              height={labels?.header?.logo?.height}
              eventClass={gaLogo}
              eventLabel={gaLogoLabel}
            /> */}
          </Link>
          <div className={style?.mainNavWrapper}>
          {screen?.isMobile ? (
              <NavigationMobile
                navigation={navigationData}
                isMobileNavOpen={isMobileNavOpen}
                toggleMobileNav={toggleMobileNav}
                variant={variant}
        				isActive = {isActive}
                language = {language}
                languageSelection={languageSelection}
              />
              ) : (
                <>
                  <NavigationDesktop
                    navigation={navigationData}
                    isTablet={screen?.isTablet && screen?.isHandheld && !screen?.isLargeHandheld}
                    isDeskTop={screen?.isDesktop}
                    variant={variant}
  				          isActive = {isActive}
                    language = {language}
                    />
                  {languageSelection?.languagesCollection ? <LanguageSelection languages={languageSelection?.languagesCollection?.items} /> : <></>}
                </>
              )}
          </div>
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  logo: PropTypes.object,
  languageSelection: PropTypes.shape({
    languages: PropTypes.array,
    defaultLanguage: PropTypes.object,
    languagesCollection: PropTypes.shape({
      items: PropTypes.array,
    }),
  }),
  navigationCollection: PropTypes.object,
  variant: PropTypes.string,
  language: PropTypes.string,
}

export default Header
